import React from 'react';
import '../styles/PropertyLinks.css';

function PropertyLinks(props) {
    const property = props.property;
    const darkMode = props.darkMode;
    const propertyEstimates = props.propertyEstimates;
    const sourceURL = props.sourceURL;
    const source = props.source;
    const subjectProperty = props.subjectProperty;
    
    // Format URL to ensure it has a protocol
    const formatUrl = (url) => {
        if (url && url !== null && url !== undefined && url !== "") {
            let formattedUrl = url.trim();
            if (!formattedUrl.match(/^https?:\/\//i)) {
                formattedUrl = 'https://' + formattedUrl;
            }
            return formattedUrl;
        }
        return "#";
    };

    // Use propertyEstimates if available, otherwise fall back to property.propertyUrls
    const zillowUrl = propertyEstimates?.zillow?.url || property.propertyUrls?.zillowUrl;
    const realtorUrl = propertyEstimates?.realtor?.url || property.propertyUrls?.realtorUrl;
    const redfinUrl = propertyEstimates?.redfin?.url || null;

    // Determine which links to show with proper null/undefined checks
    const hasZillow = zillowUrl !== null && zillowUrl !== undefined && zillowUrl !== "";
    const hasRealtor = realtorUrl !== null && realtorUrl !== undefined && realtorUrl !== "";
    const hasRedfin = redfinUrl !== null && redfinUrl !== undefined && redfinUrl !== "";
    const hasSourceURL = sourceURL !== null && sourceURL !== undefined && sourceURL !== "";
    const hasSource = source !== null && source !== undefined && source !== "";
    
    // Only show source link if both sourceURL and source are present AND it's a subject property
    const showSource = hasSourceURL && hasSource && subjectProperty === true;
    
    // Format source text: if source is "x", display as "X", otherwise use the source value
    const sourceText = showSource ? (source === "x" ? "X" : source) : null;

    return (
        <div className="property-links-container">
            {hasZillow && <a href={formatUrl(zillowUrl)} target="_blank" rel="noopener noreferrer" className={"label-regular underline cursor-pointer " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>Zillow</a>}
            {hasZillow && (hasRealtor || hasRedfin) && <span className={"label-regular " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>•</span>}
            {hasRealtor && <a href={formatUrl(realtorUrl)} target="_blank" rel="noopener noreferrer" className={"label-regular underline cursor-pointer " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>Realtor</a>}
            {hasRealtor && hasRedfin && <span className={"label-regular " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>•</span>}
            {hasRedfin && <a href={formatUrl(redfinUrl)} target="_blank" rel="noopener noreferrer" className={"label-regular underline cursor-pointer " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>Redfin</a>}
            {(hasZillow || hasRealtor || hasRedfin) && showSource && <span className={"label-regular " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>•</span>}
            {showSource && <a href={formatUrl(sourceURL)} target="_blank" rel="noopener noreferrer" className={"label-regular underline cursor-pointer " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>{sourceText}</a>}
        </div>
    )
};

export default PropertyLinks;